module.exports = __webpack_public_path__ + "img/bgtop.e5b55b83.png";